import { render, staticRenderFns } from "./SalesOrders.vue?vue&type=template&id=6a2781b8&"
import script from "./SalesOrders.vue?vue&type=script&lang=js&"
export * from "./SalesOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a2781b8')) {
      api.createRecord('6a2781b8', component.options)
    } else {
      api.reload('6a2781b8', component.options)
    }
    module.hot.accept("./SalesOrders.vue?vue&type=template&id=6a2781b8&", function () {
      api.rerender('6a2781b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/production/jobcard/jobcard-view/components/SalesOrders.vue"
export default component.exports